import editEvent from 'app/shared/eventsOld/sagas/editEvent';

const sagaRegistry = [editEvent];

export default sagaRegistry;
